import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { considerationSupportDetailsModalPayloadParts } from '@app/my-booking/sub-components/my-booking-service/sub-components/consideration-support-details-modal/consideration-support-details-modal-payload.state';
import { PassengerServiceSupportMap, ServiceSupport } from '@common/interfaces/mybooking/order-services.interface';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { SupportComponent } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes';
import { CommonLibService, ModalBlockParts, ModalService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetOrderResponseData, Traveler } from 'src/sdk-servicing';

@Component({
  selector: 'asw-consideration-support',
  templateUrl: './consideration-support.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsiderationSupportComponent extends SupportComponent {
  private _subscriptions: Subscription = new Subscription();
  // 注文応答データの取得
  pnr!: GetOrderResponseData;

  // 配慮系サポート搭乗者情報リスト
  supportPassengerInforList!: Array<Traveler>;

  constructor(
    private _common: CommonLibService,
    public change: ChangeDetectorRef,
    private _modalService: ModalService,
    private _myBookingServiceService: MyBookingServiceService,
    public _staticMsgPipe: StaticMsgPipe
  ) {
    super(_common);
  }

  reload(): void {}

  init(): void {
    this._subscriptions.add(
      this._myBookingServiceService.mybookingServiceState$.subscribe((state) => {
        this.pnr = state?.pnr ?? ({} as GetOrderResponseData);
        this.supportPassengerInforList = state?.supportPassengerInforList ?? [];
        this.change.markForCheck();
      })
    );
  }

  destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }

  // (16)「配慮系サポート詳細モーダル表示」ボタン押下処理 (item 10)
  openConsiderationSupportDetailsModal(): void {
    // 1. 配慮系サポート詳細モーダル(G01-011)を表示し、(specialServiceRequests) SSRに応じたサポートの内容を表示する。
    const part: ModalBlockParts = considerationSupportDetailsModalPayloadParts(this.pnr);
    this._modalService.showSubModal(part);
  }

  // [12.3] 搭乗者姓名
  getTravelerName(traveler?: Traveler): string {
    return this._myBookingServiceService.getTravelerName(traveler?.names);
  }

  // [12.4] 同伴搭乗者姓名
  getAccompanyingTraveler(traveler?: Traveler): string {
    return this._myBookingServiceService.getAccompanyingTraveler(traveler);
  }

  // [12.4] 同伴搭乗者姓名
  isAccompanyingTraveler(traveler?: Traveler): boolean {
    return this._myBookingServiceService.isAccompanyingTraveler(traveler);
  }

  // [12.6] 配慮系サポート情報登録状況
  getConsiderationSupportInforRegistrationStatus(travelerId?: string): string {
    const serviceSupport = (this.pnr?.services?.serviceSupport as ServiceSupport) ?? ({} as ServiceSupport);

    // [12.1] 申込済み搭乗者情報が存在する場合。申込済み搭乗者情報.serviceStatusの値に応じて、以下の通りラベル文言を設定する
    const serviceSupportTraveler = serviceSupport?.[String(travelerId)] ?? ({} as PassengerServiceSupportMap);
    switch (serviceSupportTraveler?.serviceStatus) {
      // [12.1.1] 申込済み搭乗者情報.serviceStatus=”confirmed”の場合、申込済の旨
      case ServiceSupport.ServiceStatusEnum.Confirmed:
        return this._staticMsgPipe.transform('label.registered3');

      // [12.1.2] 申込済み搭乗者情報.serviceStatus=”cancelled”の場合、キャンセルの旨
      case ServiceSupport.ServiceStatusEnum.Cancelled:
        return this._staticMsgPipe.transform('label.notApplied');

      // [12.1.3] 申込済み搭乗者情報.serviceStatus=”requesting”の場合、リクエスト中の旨
      case ServiceSupport.ServiceStatusEnum.Requesting:
        return this._staticMsgPipe.transform('label.applying');

      // [12.2] 申込済み搭乗者情報が存在しない場合、申し込まれていない旨
      default:
        return this._staticMsgPipe.transform('label.notRegistered');
    }
  }
}
